import { useCallback, useState } from 'react';

import { InstallableKentFeature } from '@cast/types-kent';

import { SelectedFeatures } from '../_types';

const DEFAULT_SELECTED_FEATURES: SelectedFeatures = {
  POD_MUTATIONS: true,
  REBALANCING: true,
  WORKLOAD_RIGHT_SIZING: true,
  SPOT_INTERRUPTION_PREDICTION: true,
  CLM: true,
};

export const useKentSelectedFeatures = (
  featureBeingInstalled?: InstallableKentFeature['type']
) => {
  const [selectedFeatures, setSelectedFeatures] = useState<SelectedFeatures>(
    DEFAULT_SELECTED_FEATURES
  );

  const toggleFeature = useCallback(
    (featureType: InstallableKentFeature['type']) => {
      setSelectedFeatures((prev) => ({
        ...prev,
        [featureType]: !prev[featureType],
      }));
    },
    []
  );

  const toggleKentSuite = useCallback(
    (shouldCheck: boolean) => {
      setSelectedFeatures({
        POD_MUTATIONS: shouldCheck,
        REBALANCING: shouldCheck,
        WORKLOAD_RIGHT_SIZING: shouldCheck,
        SPOT_INTERRUPTION_PREDICTION: shouldCheck,
        CLM: shouldCheck,
        ...(featureBeingInstalled ? { [featureBeingInstalled]: true } : {}),
      });
    },
    [featureBeingInstalled]
  );

  return {
    selectedFeatures,
    setSelectedFeatures,
    toggleFeature,
    toggleKentSuite,
  };
};
